import { Injectable } from '@angular/core';
import { BaseUrlService } from '@cbuild/core';
import { CsHttpClientService } from '@cbuild/cs-common-data-services';
import { Observable } from 'rxjs';
import { map } from 'rxjs';

@Injectable()
export class DynamicPropertyService {
  constructor(
    private http: CsHttpClientService,
    private baseUrlService: BaseUrlService
  ) {}

  public saveDynamicPropertyFiles(data: { File: File }): Observable<string> {
    return this.http
      .writeMultipart<{ result: string }>(
        'api/common/saveDynamicPropertyFiles',
        data,
        this.baseUrlService.getApiBaseURL()
      )
      .pipe(map(res => res.result));
  }
}
